import { getServiceInstance } from "./base.service";
import {
    FumigationSubmissionPayload,
    FumigationSubmissionResponse,
} from "./fumigationSubmissionPayload";

const BASE_URL = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');

/**
 * Submits a completed fumigation application.
 * The auth token is attached by the request interceptor in base.service.
 */
export const submitFumigationApplicationService = async (
    payload: FumigationSubmissionPayload,
): Promise<FumigationSubmissionResponse> => {
    try {
        const response = await getServiceInstance().post(
            `${BASE_URL}/fumigation`,
            payload,
        );
        return response.data;
    } catch (error) {
        console.error("Error submitting fumigation application:", error);
        throw error;
    }
};
